import dayjs from 'dayjs'
import { sleep } from '@enuygun/frontend-components'

import { savePreviousCategoryBeforeSubmit } from 'utils/searchForm'

import { logHomepageSearchFormSubmit, resolveHomepageSearchRef } from './searchFormSubmitTracking'
import type { SearchFormSubmitOptions } from './submitOptions'

export const transferHandleSubmit = async (form, options: SearchFormSubmitOptions = {}) => {
  const {
    index = null,
    delay = 0,
    url = 'https://www.enuygun.com',
    variant,
    productCategory,
  } = options
  const refValue = resolveHomepageSearchRef(variant)

  if (index !== null) savePreviousCategoryBeforeSubmit(String(index))
  logHomepageSearchFormSubmit({ variant, productCategory: productCategory || 'transfer' })

  const departure_time = dayjs(form.departureDate + form.departureTime).format('YYYY-MM-DD HH:mm')
  const origin_place_name = form.originLocation.place_name
  const origin_place_id = form.originLocation.place_id
  const destination_place_name = form.destinationLocation.place_name
  const destination_place_id = form.destinationLocation.place_id

  const params = new URLSearchParams({
    origin_place_id,
    destination_place_id,
    departure_time,
    origin_place_name,
    destination_place_name,
  })

  const redirectURL = `${url}/transfer/arama/?${params}&ref=${refValue}`

  await sleep(delay)

  globalThis.location.href = `${redirectURL}`
}
